<script>
    import app from "./stores/app";
    import CheckboxControl from "./controls/CheckboxControl.svelte";
    import {createEventDispatcher} from 'svelte';
    import {convertDate, JSONClone, setFocusTo} from './lib/lib';

    export let entry;

    let editNotes = false;
    let notes = '';
    let creditPrice = '';
    let totalPrice = '';
    let dateCreated = "";

    const dispatch = createEventDispatcher();

    const onPayedClick = ({detail}) => {
        $app.selectedCreditsHistoryId == entry.id;
        entry.payed = detail.checked ? 1 : 0;
        dispatch('entry_change', entry);
    }

    const onNotesClick = () => {
        $app.selectedCreditsHistoryId == entry.id;
        if (!editNotes) {
            notes = JSONClone(entry.notes);
            editNotes = true;
            setFocusTo("notes");
        }
    }

    const onNotesKeyUp = event => {
        if (event.key === "Escape" && editNotes) {
            editNotes = false;
            notes = JSONClone(entry.notes);
        }
    }

    const onNotesChange = () => {
        editNotes = false;
        if (notes !== entry.notes) {
            entry.notes = JSONClone(notes);
            notes = '';
            dispatch('entry_change', entry);
        }
    }

    $: {
        creditPrice = entry.credit_price === '0.000' ? '' : entry.credit_price;
        totalPrice = entry.total_price === '0.00' ? '' : entry.total_price;
        dateCreated = convertDate(entry.date_created);
    }
</script>

<tr class:selected={ $app.selectedCreditsHistoryId == entry.id }
    on:click="{ () => $app.selectedCreditsHistoryId = entry.id }">
    <td class="row-header">
        <span class="caption">Ημερομηνία:</span><span class="value">{ dateCreated }</span>
    </td>
    <td class="data text-right">
        <span class="caption">Μονάδες:</span>{ entry.credits }
    </td>
    <td class="data text-right">
        <span class="caption">Τιμή μονάδας:</span><span class="value">{ creditPrice }</span>
    </td>
    <td class="data text-right">
        <span class="caption">Σύνολο:</span><span class="value">{ totalPrice }</span>
    </td>
    <td class="data text-center">
        <span class="caption">Τιμολόγιο:</span>
        {#if entry.invoice === 1}
            <span class="value"><i class="fa fa-check"></i></span>
        {/if}
    </td>
    <td class="data text-center">
        <span class="caption">Πληρώθηκε:</span>
        <span class="value"><CheckboxControl css_class="inline-checkbox" checked="{ entry.payed }" on:click="{ onPayedClick }" /></span>
    </td>
    <td class="data last" on:click|preventDefault|stopPropagation="{ onNotesClick }">
        <span class="caption">Σημειώσεις:</span>
        {#if !editNotes}
            <span class="value">{ entry.notes }</span>
        {:else}
            <textarea class="form-control" id="notes" bind:value="{ notes }" on:keyup="{ onNotesKeyUp }" on:focusout="{ onNotesChange }"></textarea>
        {/if}
    </td>
</tr>